(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casestadium-upsell"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-cs-upsell]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-cs-upsell-config]').textContent);
    const discounted = price => Math.round(price * (100 - config.discount) / 100);
    const money = cents => {
      const amount = (cents / 100).toFixed(2);
      return config.moneyFormat.replace(/\{\{\s*amount(?:_no_decimals)?\s*\}\}/, amount);
    };
    const productImage = product => product?.featured_image || product?.images?.[0] || '';
    const variantOptions = product => (product?.variants || []).map(variant => `<option value="${variant.id}">${variant.title}</option>`).join('');
    const card = (product, selectable = true) => {
            if (!product?.id) return '';
      const price = product.variants?.[0]?.price || product.price || 0;
      const sale = discounted(price);
      const select = product.variants?.length > 1 ? `<select class="cs-upsell__select" aria-label="${product.title}">${variantOptions(product)}</select>` : '';
      return `<label class="cs-upsell__item" data-product-id="${product.id}">
        ${selectable ? '<input class="cs-upsell__check" type="checkbox">' : ''}
        <img class="cs-upsell__image" src="${productImage(product)}" alt="" width="128" height="128" loading="lazy">
        <span>
          <a class="cs-upsell__title" href="/products/${product.handle}">${product.title}</a>
          <span class="cs-upsell__price-row"><span class="cs-upsell__compare" data-upsell-compare>${money(price)}</span><span class="cs-upsell__price" data-upsell-price>${money(sale)}</span><span class="cs-upsell__saving" data-upsell-saving>${config.text.save} ${money(price - sale)}</span></span>
          ${select}
        </span>
      </label>`;
    };
    const renderProductOffer = () => {
      const type = root.dataset.offerType;
      if (!type) return;
      if (type === 'watch_band') {
        root.innerHTML = `<div class="cs-upsell__panel"><div class="cs-upsell__header"><h2 class="cs-upsell__heading">${config.text.multibuyHeading}</h2><span class="cs-upsell__badge">${config.multiBuyDiscount}% OFF</span></div><p class="cs-upsell__note">${config.text.multibuyText}</p></div>`;
      } else {
        const products = type === 'phone_case' ? [config.watch, config.travel] : [config.backpack];
        const heading = type === 'phone_case' ? config.text.heading : config.text.travelHeading;
        root.innerHTML = `<div class="cs-upsell__panel"><div class="cs-upsell__header"><h2 class="cs-upsell__heading">${heading}</h2><span class="cs-upsell__badge">${config.text.badge}</span></div><div class="cs-upsell__items">${products.map(product => card(product)).join('')}</div><div class="cs-upsell__footer"><span><span class="cs-upsell__total-label">${config.text.total}</span><strong class="cs-upsell__total">${money(config.currentPrice)}</strong></span><span class="cs-upsell__saving" data-total-saving></span></div></div>`;
      }
      const submit = document.querySelector('[id^="ProductSubmitButton-"]');
      const form = submit?.closest('form') || document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      form.insertAdjacentElement('afterend', root);
      root.hidden = false;
      const updateTotal = () => {
        const selected = [...root.querySelectorAll('.cs-upsell__check:checked')];
        let total = config.currentPrice;
        let saved = 0;
        selected.forEach(input => {
          const productId = Number(input.closest('[data-product-id]').dataset.productId);
          const product = [config.watch, config.travel, config.backpack].find(item => Number(item.id) === productId);
          const select = input.closest('[data-product-id]').querySelector('.cs-upsell__select');
          const variantId = Number(select?.value || product?.variants?.[0]?.id);
          const variant = product?.variants?.find(item => Number(item.id) === variantId);
          const price = variant?.price || product?.variants?.[0]?.price || product?.price || 0;
          total += discounted(price);
          saved += price - discounted(price);

          const item = input.closest('[data-product-id]');
          const compareNode = item.querySelector('[data-upsell-compare]');
          const priceNode = item.querySelector('[data-upsell-price]');
          const savingNode = item.querySelector('[data-upsell-saving]');
          if (compareNode) compareNode.textContent = money(price);
          if (priceNode) priceNode.textContent = money(discounted(price));
          if (savingNode) savingNode.textContent = `${config.text.save} ${money(price - discounted(price))}`;
        });
        const totalNode = root.querySelector('.cs-upsell__total');
        const savingNode = root.querySelector('[data-total-saving]');
        if (totalNode) totalNode.textContent = money(total);
        if (savingNode) savingNode.textContent = saved ? `${config.text.save} ${money(saved)}` : '';
      };
      root.addEventListener('change', updateTotal);
      updateTotal();
    };
    const refreshSections = sections => {
      if (!sections) return;
      ['cart-drawer', 'cart-icon-bubble'].forEach(id => {
        if (!sections[id]) return;
        const parsed = new DOMParser().parseFromString(sections[id], 'text/html');
        const incoming = parsed.querySelector(`#shopify-section-${id}`) || parsed.querySelector(`#${id}`);
        const current = document.querySelector(`#shopify-section-${id}`) || document.querySelector(`#${id}`);
        if (incoming && current) current.innerHTML = incoming.innerHTML;
      });
    };
    const addItems = async items => {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname})
      });
      if (!response.ok) throw new Error('Cart request failed');
      const result = await response.json();
      refreshSections(result.sections);
      document.querySelector('cart-drawer')?.open?.();
      return result;
    };
    const bindProductForm = () => {
      const submit = document.querySelector('[id^="ProductSubmitButton-"]');
      const form = submit?.closest('form') || document.querySelector('form[action*="/cart/add"]');
      if (!form || root.dataset.offerType === 'watch_band') return;
      const selectedItems = mainVariant => {
        const selected = [...root.querySelectorAll('.cs-upsell__check:checked')];
        const items = [{id: mainVariant, quantity: 1}];
        selected.forEach(input => {
          const item = input.closest('[data-product-id]');
          const select = item.querySelector('.cs-upsell__select');
          const productId = Number(item.dataset.productId);
          const product = [config.watch, config.travel, config.backpack].find(entry => Number(entry.id) === productId);
          items.push({id: Number(select?.value || product.variants[0].id), quantity: 1});
        });
        return items;
      };
      const submitBundle = async (mainVariant, button) => {
        if (button) button.disabled = true;
        try { await addItems(selectedItems(mainVariant)); } finally { if (button) button.disabled = false; }
      };
      form.addEventListener('submit', async event => {
        const selected = root.querySelector('.cs-upsell__check:checked');
        if (!selected) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const mainVariant = Number(form.querySelector('[name="id"]')?.value);
        if (!mainVariant) return;
        await submitBundle(mainVariant, form.querySelector('[type="submit"]'));
      }, true);

      document.addEventListener('click', async event => {
        const stickyButton = event.target.closest('#StickyATCButton');
        if (!stickyButton || !root.querySelector('.cs-upsell__check:checked')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const mainVariant = Number(document.querySelector('#sticky-variant-id')?.value || form.querySelector('[name="id"]')?.value);
        if (!mainVariant) return;
        await submitBundle(mainVariant, stickyButton);
      }, true);
    };
    const chooseDrawerOffer = cart => {
      const productIds = cart.items.map(item => Number(item.product_id));
      const hasCase = productIds.some(id => config.phoneCaseIds.map(Number).includes(id));
      const hasTravel = productIds.includes(Number(config.travel.id));
      if (hasTravel && !productIds.includes(Number(config.backpack.id))) return config.backpack;
      if (hasCase && !productIds.includes(Number(config.watch.id))) return config.watch;
      if (hasCase && !productIds.includes(Number(config.travel.id))) return config.travel;
      return null;
    };
    let drawerPending = false;
    const renderDrawerOffer = async () => {
      const drawer = document.querySelector('#CartDrawer');
      if (!drawer || drawerPending || drawer.querySelector('[data-cs-drawer-upsell]')) return;
      drawerPending = true;
      const cart = await fetch('/cart.js', {headers: {Accept: 'application/json'}}).then(response => response.json());
      const product = chooseDrawerOffer(cart);
      if (!product) { drawerPending = false; return; }
      const price = product.variants?.[0]?.price || product.price || 0;
      const select = product.variants?.length > 1 ? `<select class="cs-upsell__select" aria-label="${product.title}">${variantOptions(product)}</select>` : '';
      const wrapper = document.createElement('div');
      wrapper.className = 'cs-upsell cs-upsell__drawer';
      wrapper.dataset.csDrawerUpsell = '';
      wrapper.innerHTML = `<div class="cs-upsell__header"><h3 class="cs-upsell__heading">${config.text.drawerHeading}</h3><span class="cs-upsell__badge">${config.text.badge}</span></div><div class="cs-upsell__item"><img class="cs-upsell__image" src="${productImage(product)}" alt="" width="104" height="104" loading="lazy"><span><a class="cs-upsell__title" href="/products/${product.handle}">${product.title}</a><span class="cs-upsell__price-row"><span class="cs-upsell__compare">${money(price)}</span><span class="cs-upsell__price">${money(discounted(price))}</span></span>${select}</span><button class="cs-upsell__add" type="button">${config.text.add}</button></div>`;
      const anchor = drawer.querySelector('.cart-drawer-payment-icons') || drawer.querySelector('.drawer__footer') || drawer;
      anchor.insertAdjacentElement('beforebegin', wrapper);
      drawerPending = false;
      wrapper.querySelector('.cs-upsell__add').addEventListener('click', async event => {
        const button = event.currentTarget;
        button.disabled = true;
        const variantId = Number(wrapper.querySelector('.cs-upsell__select')?.value || product.variants[0].id);
        try {
          await adItems([{id: variantId, quantity: 1}]);
          button.textContent = config.text.added;
        } finally {
          button.disabled = false;
        }
      });
    };
    renderProductOffer();
    bindProductForm();
    document.addEventListener('click', event => {
      if (event.target.closest('#cart-icon-bubble, [data-cs-drawer-upsell]')) setTimeout(renderDrawerOffer, 250);
    });
    new MutationObserver(() => renderDrawerOffer()).observe(document.body, {childList: true, subtree: true});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
